<script>
    export default {
        methods: {
            logout: function() {
                document.getElementById('logout-form').submit();
            }
        },
    }
</script>

<template>
    <a id="global-layout-icon-logout" @click.prevent="logout">
        <i class="fa fa-sign-out"></i>
    </a>
</template>
